import { defineNuxtRouteMiddleware, navigateTo } from '#app';

export default defineNuxtRouteMiddleware(to => {
  if (to.path === '/index') {
    return navigateTo('/');
  }
});
